import css from 'styled-jsx/css';
import { sizes } from '@styles/theme';

export default css.global`
  .un-authorize-content {
    width: 100%;
    min-height: 100vh;
    padding: 24px;
    box-sizing: border-box;
    text-align: center;

    .svg-bot {
      margin-top: 0;
      margin-bottom: ${sizes.common};
    }
    .title {
      font-size: ${sizes.hecto};
      margin-bottom: ${sizes.hecto};
    }
  }
`;
